module.exports = __webpack_public_path__ + "img/picture_member_screenshot.80b8436d.png";